import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { PopupData, Service } from 'webapp-types';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import UserInviteComponent from 'webapp/components/user/invite';

export default abstract class UserPopupInvitePromoBaseComponent extends PopupInnerModalComponent<PopupData.User.UserInvitePromo> {
	@service('user-settings') declare userSettingsService: Service.UserSettings;
	@service('analytics') declare analyticsService: Service.Analytics;

	@tracked override submitInProgress = false;

	trackingOrigin = 'add_users_promotion';

	abstract get image(): string;
	abstract get title(): string;

	get description(): string {
		return 'Bring your team together to stay on top of your data.';
	}
	<template>
		<div class="content content__{{this.popupData.contentType}}">
			<div class="sides-ct has-wide-left-side">
				<div class="side side-left">
					<div class="side-left__content">
						<img src={{this.image}} alt="Promo" />
					</div>
				</div>
				<div class="side side-right">

					<div class="question-title">{{this.title}}</div>
					<div class="description">{{this.description}}</div>

					<div class="form-wrapper">
						<UserInviteComponent
							@maximumNumberOfNewUsers={{3}}
							@initialNumberOfNewUsers={{3}}
							@ignoreEmptyFields={{true}}
							@onAdminInvite={{this.close}}
							@onContentChange={{this.scheduleReposition}}
							@onClose={{this.close}}
							@trackingOrigin={{this.trackingOrigin}}
						/>
					</div>

				</div>
			</div>
		</div>
	</template>
}
